import { useTranslation } from "react-i18next";
import { motion, useReducedMotion } from "framer-motion";
import { Sparkles, Check, ShieldCheck, CreditCard } from "lucide-react";

export function TrialConfirmationBanner() {
  const { t } = useTranslation();
  const prefersReducedMotion = useReducedMotion();

  const bullets = [
    { icon: Check, text: t("authTrialBanner.b1", "Full access to every Pro feature") },
    { icon: CreditCard, text: t("offerDetails.card") },
    { icon: ShieldCheck, text: t("offerDetails.cancel") },
  ];

  return (
    <motion.div
      initial={prefersReducedMotion ? {} : { opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="w-full max-w-md mb-5"
    >
      <div className="rounded-2xl border border-primary/25 bg-gradient-to-br from-primary/8 via-primary/5 to-emerald-500/5 p-5 shadow-sm">
        <div className="flex items-start gap-3 mb-3">
          <div className="flex items-center justify-center w-10 h-10 shrink-0 rounded-xl bg-primary/15 text-primary">
            <Sparkles className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <h2 className="text-sm font-bold text-foreground leading-snug">
              {t("authTrialBanner.title", "Your 7-day free trial is ready")}
            </h2>
            <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">
              {t("offerDetails.setup")}
            </p>
          </div>
        </div>

        <ul className="space-y-1.5 pl-1">
          {bullets.map((b, i) => {
            const Icon = b.icon;
            return (
              <li key={i} className="flex items-start gap-2 text-xs text-foreground/85">
                <Icon className="w-3.5 h-3.5 text-primary shrink-0 mt-0.5" />
                <span>{b.text}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </motion.div>
  );
}
